<fieldset
  class="ds-option"
  role="listbox"
  [class.ds-fluid]="fluid"
  [class.ds-small]="small"
  [class.ds-row]="horizontal"
  [class.ds-invalid]="validate && isTouched && isInvalid"
  [class.ds-valid]="validate && isTouched && isValid"
  [attr.disabled]="isDisabled || null"
  [attr.aria-invalid]="isInvalid"
  [attr.aria-describedby]="'alert-' + id"
  [attr.aria-multiselectable]="multiple"
  [attr.aria-required]="required"
>
  <label
    *ngFor="
      let inputOptionDirective of inputOptionDirectives;
      let first = first
    "
    role="option"
    [tabindex]="first ? 0 : -1"
    [attr.aria-checked]="inputOptionDirective.selected"
    (blur)="onTouched()"
    (click)="!isDisabled && onSelected($event, inputOptionElement)"
    (keydown)="!isDisabled && onNavigate($event)"
    [class.ds-check-group]="inputOptionDirective.sublabel"
    [class.ds-text-center]="inputOptionDirective.sublabel"
  >
    <input
      #inputOptionElement
      tabindex="-1"
      [disabled]="isDisabled"
      [name]="id"
      [type]="multiple ? 'checkbox' : 'radio'"
      [value]="inputOptionDirective.value"
      [checked]="inputOptionDirective.selected"
    />
    <div>
      <span
        [class.ds-px-sm]="inputOptionDirective.sublabel"
        [class.ds-block]="inputOptionDirective.sublabel"
        [class.ds-font-medium]="inputOptionDirective.sublabel"
      >
        {{
          inputOptionDirective.label ||
            inputOptionDirective.elementRef.nativeElement.textContent
        }}
      </span>
      <span *ngIf="inputOptionDirective.sublabel" class="ds-text-sm ds-block">
        {{ inputOptionDirective.sublabel }}
      </span>
    </div>
  </label>
</fieldset>
<div class="ds-text-xs ds-mt-2xs" [id]="'alert-' + id">
  <span role="alert" class="ds-text-secondary-red ds-opacity-80">
    {{ error }}
  </span>
  <span class="ds-text-tertiary-mediumgrey">
    {{ hint }}
  </span>
</div>

<select
  #inputElement
  class="ds-hidden"
  aria-hidden="true"
  [multiple]="multiple"
  [required]="required"
>
  <!--
    Adding a blank option to have an indetermented state, similarly to
    the visible list selector.
  -->
  <option hidden selected></option>
  <option
    *ngFor="let inputOptionDirective of inputOptionDirectives"
    [value]="inputOptionDirective.value"
    [selected]="inputOptionDirective.selected"
  >
    {{ inputOptionDirective.elementRef.nativeElement.textContent }}
  </option>
</select>
